// A "Back to Getting Started" link shown at the top of any page reached from the
// setup checklist (the step Links carry ?from=setup). Rendered once in the tenant
// layout so every step — Departments, Holidays, Migration Center, … — gets a way
// back out without editing each page. Renders nothing on pages reached any other
// way (e.g. the sidebar), so normal admin navigation is unaffected.
import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const SetupBackLink: React.FC = () => {
  const [params] = useSearchParams();
  const { tenantSlug } = useParams();
  const { t } = useTranslation('onboarding');
  if (params.get('from') !== 'setup') return null;
  const to = tenantSlug ? `/t/${tenantSlug}/app/admin/setup` : '/app/admin/setup';
  return (
    <Link
      to={to}
      className="mb-4 inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
    >
      <ArrowLeft className="w-4 h-4" /> {t('setup.back_to_setup', 'Back to Getting Started')}
    </Link>
  );
};

export default SetupBackLink;
